var _ = require('underscore');
var $ = require('jquery');
var TorsoCollection = require('backbone-torso/modules/Collection');
var GipMerchantAccountModel = require('./GipMerchantAccountModel');
var gipMerchantAccountExtService = require('./../../../../urls').gipMerchantAccountExtService;

/**
 * Receives merchant accounts from the GipAccountMerchantExtService
 * @class gipMerchantAccountCollection
 * @extends Torso.Collection
 */
module.exports = new (TorsoCollection.extend({
  model: GipMerchantAccountModel,
  url: gipMerchantAccountExtService,
  fetchHttpAction: 'POST',

  /**
   * Initialize this collection.
   */
  initialize: function() {
    _.bindAll(this, '_trackAndFetchPartialList', '_findAndReturnDefaultAccount');
  },

  /**
   * Only makes sense for private collections.  Nobody cares (or shouldn't) how the cache is ordered.
   * @method comparator
   * @param model {Backbone.Model} the model to index for this collection.
   * @returns {Number} a unique index that can be used to sort this model.
   *      Represents the index of this model's id in the tracked ids of this private collection.
   */
  comparator: function(model) {
    if (!this.trackedIds) {
      return undefined;
    }
    return _.indexOf(this.trackedIds, model.get(model.idAttribute));
  },

  /**
   * Fetch a list of vecnaIds by criteria
   * @method fetchIdsByCriteria
   * @param criteria {Object} criteria suitable for the gipMerchantAccountExtService
   * @return A Promise wrapping a list of ids
   */
  fetchIdsByCriteria: function(criteria) {
    return $.ajax({
      url: gipMerchantAccountExtService + '/criteria',
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify(criteria)
    });
  },

  /**
   * Get the default account from the cache and go fetch it if it isn't there.
   *
   * @method getOrFetchDefaultAccount
   * @return {GipMerchantAccountModel} the model that has defaultAccount set to true.
   */
  getOrFetchDefaultAccount: function() {
    try {
      return $.Deferred.resolve(this._findAndReturnDefaultAccount()).promise();
    } catch (error) {
      return this.fetchIdsByCriteria({ 'defaultAccount': true })
        .then(this._trackAndFetchPartialList);
    }
  },

  /**
   * Track the default account identifier as an id for this cache collection.
   *
   * @method _trackAndFetchPartialList
   * @param idsPartialList {Object}
   *   @param idsPartialList.list {String[]} the list of ids that are part of a partial list.
   * @return {Promise<GipMerchantAccountModel>} a promise that resolves to the account model or fails with an error.
   * @private
   */
  _trackAndFetchPartialList: function(idsPartialList) {
    var newIds = idsPartialList.list;
    this.registerIds(newIds, this.cid);
    return this.fetchByIds({ idsToFetch: newIds })
      .then(this._findAndReturnDefaultAccount);
  },

  /**
   * Returns the default account if it is in the cache or throws an error if it is not.
   *
   * @method _findAndReturnDefaultAccount
   * @return {GipMerchantAccountModel} the default model if it exists.
   * @throws if there is no default account in the cache already.
   * @private
   */
  _findAndReturnDefaultAccount: function() {
    var existingDefaultAccount = this.findWhere({'defaultAccount': true});
    if (existingDefaultAccount) {
      return existingDefaultAccount;
    } else {
      throw 'No default account';
    }
  },

  /**
   * Sets account to default and all other accounts to not default
   * @method defaultAccount
   * @param vecnaId {String} vecnaId used to identify the default account.
   * @return A Promise wrapping a list of ids
   */
  defaultAccount: function(vecnaId) {
    return $.ajax({
      url: gipMerchantAccountExtService + '/' + vecnaId + '/default',
      contentType: 'application/json',
      type: 'PUT'
    });
  }
}))();
